import { doGetOld } from './base'

export const getSetting = async (id: string): Promise<SettingsResponse> => {
  return await doGetOld(`/api/settings/${id}`)
}

export default {
  getSetting
}
